import styled from 'styled-components'

export const OldPrice = styled.del`
  color: #75818c;
  margin-right: 4px;
  font-weight: 800;
`
